<template>
    <div>
        <v-card outlined class="pa-4 mb-4">
            <div class="d-flex flex-wrap align-center justify-space-between">
                <div>
                    <div class="secao-titulo">Equipe e comissões</div>
                    <div class="caption grey--text text--darken-1">
                        Percentual pago ao barbeiro por categoria de serviço e meta mensal de faturamento.
                        Informe em porcentagem — 40 significa 40%.
                    </div>
                </div>

                <v-btn
                    color="green darken-2"
                    dark
                    class="mt-3 mt-md-0"
                    :loading="salvando"
                    :disabled="!formValido"
                    @click="salvar"
                >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar comissões
                </v-btn>
            </div>
        </v-card>

        <v-card outlined class="pa-4">
            <v-row
                v-for="linha in linhas"
                :key="linha.id"
                align="center"
                class="linha-barbeiro"
            >
                <v-col cols="12" md="3">
                    <div class="font-weight-bold teal--text text--darken-3">
                        {{ linha.nome }}
                    </div>
                    <div v-if="linha.inativo" class="caption orange--text text--darken-3">
                        Fora do cadastro atual — mantido para o histórico
                    </div>
                </v-col>

                <v-col cols="6" sm="4" md="0" lg="1" class="col-percentual">
                    <campo-valor
                        v-model="linha.corte"
                        suffix="%"
                        label="Corte" dense outlined hide-details="auto"
                        :error-messages="erroPercentual(linha.corte)"
                    ></campo-valor>
                </v-col>

                <v-col cols="6" sm="4" md="0" lg="1" class="col-percentual">
                    <campo-valor
                        v-model="linha.barba"
                        suffix="%"
                        label="Barba" dense outlined hide-details="auto"
                        :error-messages="erroPercentual(linha.barba)"
                    ></campo-valor>
                </v-col>

                <v-col cols="6" sm="4" md="0" lg="2" class="col-percentual">
                    <campo-valor
                        v-model="linha.corteBarba"
                        suffix="%"
                        label="Corte + Barba" dense outlined hide-details="auto"
                        :error-messages="erroPercentual(linha.corteBarba)"
                    ></campo-valor>
                </v-col>

                <v-col cols="6" sm="4" md="0" lg="1" class="col-percentual">
                    <campo-valor
                        v-model="linha.outros"
                        suffix="%"
                        label="Outros" dense outlined hide-details="auto"
                        :error-messages="erroPercentual(linha.outros)"
                    ></campo-valor>
                </v-col>

                <v-col cols="12" sm="4" md="3" lg="2">
                    <campo-valor
                        v-model="linha.meta"
                        prefix="R$"
                        label="Meta mensal" dense outlined hide-details
                    ></campo-valor>
                </v-col>
            </v-row>

            <div v-if="!linhas.length" class="text-center grey--text py-8">
                Nenhum barbeiro cadastrado. Cadastre a equipe em Barbeiros primeiro.
            </div>
        </v-card>

        <v-alert dense text type="info" class="mt-4 caption">
            Alterar um percentual recalcula também os lançamentos já registrados, como acontece
            na planilha. Se precisar preservar um fechamento antigo, exporte-o antes de mudar.
        </v-alert>
    </div>
</template>

<script>
import { salvarComissoes } from '@/services/financeiro'
import { numero } from '@/services/financeiroCalculos'
import CampoValor from './CampoValor'

export default {
    components: { CampoValor },

    props: ['comissoes', 'barbeiros', 'usuario'],

    data(){
        return {
            linhas: [],
            salvando: false
        }
    },

    computed: {
        formValido(){
            return this.linhas.every((linha) => {
                return [linha.corte, linha.barba, linha.corteBarba, linha.outros]
                    .every((valor) => this.erroPercentual(valor) === '')
            })
        }
    },

    watch: {
        comissoes: {
            immediate: true,
            handler(){
                this.sincronizar()
            }
        }
    },

    methods: {
        // Os percentuais sao gravados como fracao (0,4) e editados como
        // porcentagem (40), que e como o dono pensa no dia a dia.
        sincronizar(){
            this.linhas = Object.keys(this.comissoes || {}).map((id) => {
                const item = this.comissoes[id]
                return {
                    id,
                    nome: item.nome || id,
                    inativo: !!item.inativo,
                    corte: numero(item.corte) * 100,
                    barba: numero(item.barba) * 100,
                    corteBarba: numero(item.corteBarba) * 100,
                    outros: numero(item.outros) * 100,
                    meta: numero(item.meta)
                }
            }).sort((a, b) => (a.nome || '') > (b.nome || '') ? 1 : -1)
        },

        erroPercentual(valor){
            const convertido = numero(valor)
            if(convertido < 0 || convertido > 100){
                return 'Use um valor entre 0 e 100'
            }
            return ''
        },

        async salvar(){
            if(!this.formValido){
                return
            }

            this.salvando = true
            try {
                const comissoes = {}
                this.linhas.forEach((linha) => {
                    comissoes[linha.id] = {
                        nome: linha.nome,
                        corte: numero(linha.corte) / 100,
                        barba: numero(linha.barba) / 100,
                        corteBarba: numero(linha.corteBarba) / 100,
                        outros: numero(linha.outros) / 100,
                        meta: numero(linha.meta),
                        inativo: linha.inativo
                    }
                })

                await salvarComissoes(comissoes, this.usuario)
                this.$toasted.global.defaultSuccess('Comissões salvas!')
                this.$emit('recarregar')
            } catch (error) {
                this.$toasted.global.defaultError({ msg: error.message })
            } finally {
                this.salvando = false
            }
        }
    }
}
</script>

<style scoped>
.secao-titulo {
    font-size: 18px;
    font-weight: 800;
    color: #14312d;
}

.linha-barbeiro + .linha-barbeiro {
    border-top: 1px solid rgba(0, 105, 92, 0.12);
    margin-top: 4px;
    padding-top: 8px;
}

.col-percentual {
    min-width: 110px;
}
</style>
